const routes = [
  {
    path: '/gathering',
    name: 'GatheringPage',
    meta: { label: '' },
    component: () => import('@/views/gathering/index.vue')
  },
  // {
  //   path: '/gathering/main-gas-pipelines', //временно убираем остальные вкладки слета
  //   name: 'MainGasPipelinesPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/MainGasPipelines.vue')
  // },
  // {
  //   path: '/gathering/digital-diagnostics',
  //   name: 'DigitalDiagnosticsPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/DigitalDiagnostics.vue')
  // },
  // {
  //   path: '/gathering/communication-systems',
  //   name: 'CommunicationSystemsPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/CommunicationSystems.vue')
  // },
  // {
  //   path: '/gathering/industrial-safety',
  //   name: 'IndustrialSafetyPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/IndustrialSafety.vue')
  // },
  // {
  //   path: '/gathering/energy-supply',
  //   name: 'EnergySupplyPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/EnergySupply.vue')
  // },
  // {
  //   path: '/gathering/business-informatics',
  //   name: 'BusinessInformaticsPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/BusinessInformatics.vue')
  // },
  // {
  //   path: '/gathering/poll',
  //   name: 'PollPage',
  //   meta: { label: '' },
  //   component: () => import('@/views/gathering/Poll.vue')
  // }
]
export default routes
